import { render, staticRenderFns } from "./langLabel.vue?vue&type=template&id=32c7484b"
import script from "./langLabel.vue?vue&type=script&lang=js"
export * from "./langLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c7484b')) {
      api.createRecord('32c7484b', component.options)
    } else {
      api.reload('32c7484b', component.options)
    }
    module.hot.accept("./langLabel.vue?vue&type=template&id=32c7484b", function () {
      api.rerender('32c7484b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/lang/langLabel.vue"
export default component.exports